export enum DocumentsHeaderSortKeys {
  name,
  category,
  validUntil,
}

export enum EndedAssignmentsListHeaderSortKeys {
  period,
  department,
  qualification,
}
